import React, { Component } from 'react';
import { Layout, Collapse, Icon, Table, Row, Col, Form, DatePicker, Input, Select, Button, Spin, Modal, Checkbox, Radio, Upload, Cascader, Tabs, Card, List } from 'antd';
import { FormattedMessage, useIntl, injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { filter, last, find, includes } from 'lodash';
import { toUpperKey } from '../../../../../util/helpper';
import moment from 'moment';
import './Category.css';
import ScrollToTop from '../../../../../components/ScrollToTop';
import MenuSider from '../../../../../components/MenuSider';
import IntlMessages from '../../../../../util/IntlMessages';
import DateTimeFormat from '../../../../../Constants/DateTimeFormat';
import { Odata_Url, Constants } from '../../../../../Constants/Constants';
import Local from '../../../../../Constants/Local';

const { Panel } = Collapse;
const { Content } = Layout;
const { Column } = Table;
const { RangePicker } = DatePicker;
const { Option } = Select;
const CheckboxGroup = Checkbox.Group;
const RadioGroup = Radio.Group;
const FormItem = Form.Item;
const TabPane = Tabs.TabPane;
const { TextArea } = Input;


class Category extends Component {

    constructor(prop) {
        super(prop);

        this.state = { }
    }

    componentDidMount() {

    }

    validate = () => {
        const result = {
            isPass: true,
            msg: "",
        };
        const optCategorySelecteds = this.props.optCategorySelecteds;

        optCategorySelecteds.forEach(category => {
            if (category.subCategories) {

                let haveSelected = false;
                category.subCategories.forEach((subCate) => {
                    if (subCate.unSafe === 0 || subCate.unSafe === 1) {
                        haveSelected = true;
                    }
                });

                if (!haveSelected) {
                    result.isPass = false;
                    result.msg = this.props.intl.formatMessage({ id: 'category.validate.error.select' });
                }

                //category.subCategories.forEach((subCate) => {
                //    if (subCate.unSafe === undefined || subCate.unSafe === null) {
                //        result.isPass = false;
                //        result.msg = this.props.intl.formatMessage({ id: 'category.validate.error.select' });
                //    }
                //});
            }
        });

        if (result.isPass) {
            optCategorySelecteds.forEach(category => {
                if (this._categoryIncludeUnSafe(category) && !category.detail) {
                    result.isPass = false;
                    result.msg = this.props.intl.formatMessage({ id: 'category.validate.error.detail' });
                }
            });
        }

        return result;
    }

    onClickChangeSubCateResult = (subCate) => {
        this.props.onClickChangeSubCateResult(subCate);
    }

    onCategoryDetailChange = (category, value) => {
        this.props.onCategoryDetailChange(category, value);
    }

    _categoryIncludeUnSafe = (category) => {
        if (!category.subCategories) {
            return false;
        }
        let catHaveUnSafe = find(category.subCategories, subCate => {
            return subCate.unSafe === 1;
        });

        let isCatHaveUnSafe = false;
        if (catHaveUnSafe) {
            isCatHaveUnSafe = true;
        }

        return isCatHaveUnSafe;
    }

    getTokenHeader = () => {
        var $getToken = new Promise((resolve, reject) => {
            axios.get('auth/token').then((res) => {
                const tokenHeader = { headers: { "Authorization": "Bearer " + res.data } };
                resolve(tokenHeader);
            }).catch(err => {
                if (401 === err.response.status) {
                    localStorage.setItem("ObsReqRedirectAfterLogin", "ObsReqRedirectAfterLogin");
                    window.location.href = "auth";
                }
                reject(err);
            });
        });
        return $getToken;
    }

    render() {
        const view = this.props.isReadonly;
        const local = this.props.intl ? this.props.intl.locale : Local.TH;
        const validated = this.props ? this.props.validated : false;
        const optCategorySelecteds = this.props.optCategorySelecteds ? this.props.optCategorySelecteds : [];
        const observationTrn = this.props.observationTrn ? this.props.observationTrn : {};
        console.log(view)
        return (
            <Card size="small">
                {optCategorySelecteds.map(category => {
                    return (<Card title={<strong>{local === Local.TH ? category.Category_Name : category.Category_Name_EN}</strong>} size="small" style={{ marginBottom: "5px" }}>
                        <List bordered={false}>
                            {(category.subCategories ? category.subCategories : []).map(subCate => {

                                let btnText = "N/A";
                                let btnClassName = "subcate-btn-na";
                                if (subCate.unSafe === 0) {
                                    btnText = "Safe";
                                    btnClassName = "subcate-btn-safe";
                                }
                                else if (subCate.unSafe === 1) {
                                    btnText = "Unsafe";
                                    btnClassName = "subcate-btn-unsafe";
                                }
                                else {
                                    btnText = "N/A";
                                    btnClassName = "subcate-btn-na";
                                }

                                return (<List.Item>
                                    <div style={{ width: "100%" }}>
                                        <Row>
                                            <Col xs={1} sm={1} md={1} lg={1} xl={1}>
                                                {subCate.SeqNo}
                                            </Col>
                                            <Col xs={17} sm={19} md={19} lg={19} xl={19}>
                                                {local === Local.TH ? subCate.SubCategory_Name : subCate.SubCategory_Name_EN}
                                            </Col>
                                            <Col xs={6} sm={4} md={4} lg={4} xl={4}>
                                                <Button size="default" disabled={view} type="link" className={btnClassName} style={{ width: "100%" }} onClick={() => { this.onClickChangeSubCateResult(subCate) }}>
                                                    {btnText}
                                                </Button>
                                            </Col>
                                        </Row>
                                    </div>
                                </List.Item>);
                            })}
                        </List>
                        <Row>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Form.Item label={<IntlMessages id="Details" />}
                                    required={this._categoryIncludeUnSafe(category)}
                                    validateStatus={validated && this._categoryIncludeUnSafe(category) && !category.detail ? "error" : "success"}>
                                    <TextArea disabled={ view} rows={3} value={category.detail} onChange={(e) => { this.onCategoryDetailChange(category, e.target.value) }} />
                                </Form.Item>
                            </Col>
                        </Row>

                    </Card>)
                })}
            </Card>
            );
    }

}

export default injectIntl(Category, { withRef: true });